import { createSelector } from "@reduxjs/toolkit";
import { BetRadarEventType, OutcomeTypes, BetRadarEntityStatus, EventStatus } from "@nxplatform/platform-entities/sport/common-sport.entities";
import { AppStorage } from "@service/api-client/http/helpers/AppStorage";
import { __ } from "@service/api-client/http/helpers/translates";
import { makeMarketSortedNames } from "../../common/market-names.js";
import { analytics, favorites, boostedOdds } from "../../constants/betbooster.js";
import { hasBoostedOdds } from "../../event/has-boosted-odds.js";
const betRadarSetupOutcomes = "betOutcomes";
const betRadarSetupMarkets = "betMarkets";
const betRadarSetupStatus = "betStatus";
const betRadarSetupVariants = "betVariants";
const getMarketTranslations = () => {
  var _a;
  return (_a = AppStorage.get(betRadarSetupMarkets)) == null ? void 0 : _a.items;
};
const getOutcomesTranslations = () => {
  var _a;
  return (_a = AppStorage.get(betRadarSetupOutcomes)) == null ? void 0 : _a.items;
};
const getVariantTranslations = () => AppStorage.get(betRadarSetupVariants);
const BetRadarFactorTypes = {
  [
    "winnerSuperOver"
    /* winnerSuperOver */
  ]: 6,
  [
    "winnerInclOvertime"
    /* winnerInclOvertime */
  ]: 262,
  [
    "total"
    /* total */
  ]: 289,
  [
    "overtimeTotal"
    /* overtimeTotal */
  ]: 292,
  [
    "totalMaps"
    /* totalMaps */
  ]: 382,
  [
    "inningTotal"
    /* inningTotal */
  ]: 405,
  [
    "dblChance"
    /* dblChance */
  ]: 545,
  [
    "handicap"
    /* handicap */
  ]: 557,
  [
    "pointHandicap"
    /* pointHandicap */
  ]: 598,
  [
    "outcomes"
    /* outcomes */
  ]: 621,
  [
    "setHandicap"
    /* setHandicap */
  ]: 637,
  [
    "winnerInclInning"
    /* winnerInclInning */
  ]: 701,
  [
    "mapHandicap"
    /* mapHandicap */
  ]: 705,
  [
    "handicapInning"
    /* handicapInning */
  ]: 710,
  [
    "totalGames"
    /* totalGames */
  ]: 711,
  [
    "totalPoints"
    /* totalPoints */
  ]: 761,
  [
    "frameTotal"
    /* frameTotal */
  ]: 884,
  [
    "winner"
    /* winner */
  ]: 910,
  [
    "winnerMore"
    /* winnerMore */
  ]: 921,
  [
    "totalSets"
    /* totalSets */
  ]: 1009,
  [
    "totalInning"
    /* totalInning */
  ]: 1037,
  [
    "frameHandicap"
    /* frameHandicap */
  ]: 1060,
  [
    "gameHandicap"
    /* gameHandicap */
  ]: 1081,
  [
    "overtimeHandicap"
    /* overtimeHandicap */
  ]: 1084,
  [
    "setWinner"
    /* setWinner */
  ]: 789,
  [
    "gameWinner"
    /* gameWinner */
  ]: 479,
  [
    "competitor1Total"
    /* competitor1Total */
  ]: 190,
  // Soccer
  [
    "competitor2Total"
    /* competitor2Total */
  ]: 242,
  // Soccer
  [
    "firstHalfTotal"
    /* firstHalfTotal */
  ]: 115,
  // Soccer
  [
    "firstHalfCompetitor1Total"
    /* firstHalfCompetitor1Total */
  ]: 15,
  // Soccer
  [
    "firstHalfCompetitor2Total"
    /* firstHalfCompetitor2Total */
  ]: 326,
  // Soccer
  [
    "secondHalfTotal"
    /* secondHalfTotal */
  ]: 338,
  // Soccer
  [
    "secondHalfCompetitor1Total"
    /* secondHalfCompetitor1Total */
  ]: 442,
  // Soccer
  [
    "secondHalfCompetitor2Total"
    /* secondHalfCompetitor2Total */
  ]: 712,
  // Soccer
  [
    "totalCorners"
    /* totalCorners */
  ]: 906,
  // Soccer
  [
    "firstHalfTotalCorners"
    /* firstHalfTotalCorners */
  ]: 1069,
  // Soccer
  [
    "totalBookings"
    /* totalBookings */
  ]: 180,
  // Soccer
  [
    "firstHalfTotalBookings"
    /* firstHalfTotalBookings */
  ]: 629,
  // Soccer
  [
    "totalBookingsPoints"
    /* totalBookingsPoints */
  ]: 949,
  // Soccer
  [
    "firstHalfTotalBookingsPoints"
    /* firstHalfTotalBookingsPoints */
  ]: 348,
  // Soccer
  [
    "threeWayBetting"
    /* threeWayBetting */
  ]: 656,
  // Soccer
  [
    "totalAndBothTeamsToScore"
    /* totalAndBothTeamsToScore */
  ]: 484,
  // Soccer
  [
    "firstHalfThreeWayBetting"
    /* firstHalfThreeWayBetting */
  ]: 982,
  // Soccer
  [
    "secondHalfThreeWayBetting"
    /* secondHalfThreeWayBetting */
  ]: 819,
  // Soccer
  [
    "doubleChanceAndTotal"
    /* doubleChanceAndTotal */
  ]: 234,
  // Soccer
  [
    "halfTimeFullTimeTotal"
    /* halfTimeFullTimeTotal */
  ]: 427,
  // Soccer
  [
    "halfTimeFullTimeFirstHalfTotal"
    /* halfTimeFullTimeFirstHalfTotal */
  ]: 95,
  // Soccer
  [
    "handicapHcp"
    /* handicapHcp */
  ]: 893,
  // Soccer
  [
    "firstHalfHandicap"
    /* firstHalfHandicap */
  ]: 836,
  // Soccer
  [
    "firstHalfHandicapHcp"
    /* firstHalfHandicapHcp */
  ]: 961,
  // Soccer
  [
    "secondHalfHandicap"
    /* secondHalfHandicap */
  ]: 310,
  // Soccer
  [
    "secondHalfHandicapHcp"
    /* secondHalfHandicapHcp */
  ]: 898,
  // Soccer
  [
    "cornerHandicap"
    /* cornerHandicap */
  ]: 73,
  // Soccer
  [
    "firstHalfCornerHandicap"
    /* firstHalfCornerHandicap */
  ]: 43,
  // Soccer
  [
    "gameTotalPoints"
    /* gameTotalPoints */
  ]: 184,
  // Badminton
  [
    "gamePointHandicap"
    /* gamePointHandicap */
  ]: 341,
  // Badminton
  [
    "innings1To5Total"
    /* innings1To5Total */
  ]: 887,
  // Baseball
  [
    "competitor1TotalIncludeExtraInnings"
    /* competitor1TotalIncludeExtraInnings */
  ]: 108,
  // Baseball
  [
    "competitor2TotalIncludeExtraInnings"
    /* competitor2TotalIncludeExtraInnings */
  ]: 483,
  // Baseball
  [
    "totalOverExactUnderIncludeExtraInnings"
    /* totalOverExactUnderIncludeExtraInnings */
  ]: 494,
  // Baseball
  [
    "innings1to5Competitor1Total"
    /* innings1to5Competitor1Total */
  ]: 959,
  // Baseball
  [
    "innings1to5Competitor2Total"
    /* innings1to5Competitor2Total */
  ]: 932,
  // Baseball
  [
    "winnerAndTotalIncludeExtraInnings"
    /* winnerAndTotalIncludeExtraInnings */
  ]: 293,
  // Baseball
  [
    "totalHitsIncludeExtraInnings"
    /* totalHitsIncludeExtraInnings */
  ]: 989,
  // Baseball
  [
    "competitor1TotalHitsIncludeExtraInnings"
    /* competitor1TotalHitsIncludeExtraInnings */
  ]: 861,
  // Baseball
  [
    "competitor2TotalHitsIncludeExtraInnings"
    /* competitor2TotalHitsIncludeExtraInnings */
  ]: 537,
  // Baseball
  [
    "inningTotalHits"
    /* inningTotalHits */
  ]: 559,
  // Baseball
  [
    "inningCompetitor1TotalHits"
    /* inningCompetitor1TotalHits */
  ]: 117,
  // Baseball
  [
    "inningCompetitor2TotalHits"
    /* inningCompetitor2TotalHits */
  ]: 515,
  // Baseball
  [
    "innings1To5TotalHits"
    /* innings1To5TotalHits */
  ]: 1001,
  // Baseball
  [
    "innings1To5Competitor1TotalHits"
    /* innings1To5Competitor1TotalHits */
  ]: 370,
  // Baseball
  [
    "innings1To5Competitor2TotalHits"
    /* innings1To5Competitor2TotalHits */
  ]: 573,
  // Baseball
  [
    "totalHomeRunsIncludeExtraInnings"
    /* totalHomeRunsIncludeExtraInnings */
  ]: 53,
  // Baseball
  [
    "competitor1TotalHomeRunsIncludeExtraInnings"
    /* competitor1TotalHomeRunsIncludeExtraInnings */
  ]: 52,
  // Baseball
  [
    "competitor2TotalHomeRunsIncludeExtraInnings"
    /* competitor2TotalHomeRunsIncludeExtraInnings */
  ]: 688,
  // Baseball
  [
    "innings1To5Handicap"
    /* innings1To5Handicap */
  ]: 845,
  // Baseball
  [
    "quarternrTotal"
    /* quarternrTotal */
  ]: 581,
  // Basketball
  [
    "quarternrCompetitor1Total"
    /* quarternrCompetitor1Total */
  ]: 77,
  // Basketball
  [
    "quarternrCompetitor2Total"
    /* quarternrCompetitor2Total */
  ]: 65,
  // Basketball
  [
    "competitor1TotalMaximumConsecutivePoints"
    /* competitor1TotalMaximumConsecutivePoints */
  ]: 229,
  // Basketball
  [
    "competitor2TotalMaximumConsecutivePoints"
    /* competitor2TotalMaximumConsecutivePoints */
  ]: 446,
  // Basketball
  [
    "anyTeamTotalMaximumConsecutivePoints"
    /* anyTeamTotalMaximumConsecutivePoints */
  ]: 881,
  // Basketball
  [
    "competitor1TotalIncludeOvertime"
    /* competitor1TotalIncludeOvertime */
  ]: 66,
  // Basketball
  [
    "competitor2TotalIncludeOvertime"
    /* competitor2TotalIncludeOvertime */
  ]: 383,
  // Basketball
  [
    "winnerAndTotalIncludeOvertime"
    /* winnerAndTotalIncludeOvertime */
  ]: 976,
  // Basketball
  [
    "totalOverExactUnder"
    /* totalOverExactUnder */
  ]: 397,
  // Basketball
  [
    "quarternrHandicap"
    /* quarternrHandicap */
  ]: 102,
  // Basketball
  [
    "setTotalPoints"
    /* setTotalPoints */
  ]: 490,
  // Beach Volley
  [
    "setPointHandicap"
    /* setPointHandicap */
  ]: 47,
  // Beach Volley
  [
    "inningsCompetitor1Total"
    /* inningsCompetitor1Total */
  ]: 374,
  // Cricket
  [
    "inningsCompetitor2Total"
    /* inningsCompetitor2Total */
  ]: 771,
  // Cricket
  [
    "inningsOversZeroToCompetitor1Total"
    /* inningsOversZeroToCompetitor1Total */
  ]: 460,
  // Cricket
  [
    "inningsOversZeroToCompetitor2Total"
    /* inningsOversZeroToCompetitor2Total */
  ]: 728,
  // Cricket
  [
    "firstOverTotal"
    /* firstOverTotal */
  ]: 200,
  // Cricket
  [
    "total180s"
    /* total180s */
  ]: 235,
  // Darts
  [
    "setTotalLegs"
    /* setTotalLegs */
  ]: 690,
  // Darts
  [
    "competitor1Total180s"
    /* competitor1Total180s */
  ]: 22,
  // Darts
  [
    "competitor2Total180s"
    /* competitor2Total180s */
  ]: 869,
  // Darts
  [
    "setLegHandicap"
    /* setLegHandicap */
  ]: 423,
  // Darts
  [
    "handicap180s"
    /* handicap180s */
  ]: 971,
  // Darts
  [
    "mapTotalRoundsIncludeOvertime"
    /* mapTotalRoundsIncludeOvertime */
  ]: 892,
  // Counter Strike
  [
    "mapRoundHandicapIncludeOvertime"
    /* mapRoundHandicapIncludeOvertime */
  ]: 267,
  // Counter Strike
  [
    "setTotalGames"
    /* setTotalGames */
  ]: 840,
  // Tennis
  [
    "competitor1TotalGames"
    /* competitor1TotalGames */
  ]: 351,
  // Tennis
  [
    "competitor2TotalGames"
    /* competitor2TotalGames */
  ]: 455,
  // Tennis
  [
    "winnerAndTotal"
    /* winnerAndTotal */
  ]: 996,
  // Tennis
  [
    "setGameHandicap"
    /* setGameHandicap */
  ]: 678,
  // Tennis
  [
    "asianTotal"
    /* asianTotal */
  ]: 1090,
  [
    "asianHandicap"
    /* asianHandicap */
  ]: 1091,
  [
    "moneyLineInclOvertimeAndPenalties"
    /* moneyLineInclOvertimeAndPenalties */
  ]: 732,
  [
    "spreadInclOvertimeAndPenalties"
    /* spreadInclOvertimeAndPenalties */
  ]: 911,
  [
    "totalIncOvertimeAndPenalties"
    /* totalIncOvertimeAndPenalties */
  ]: 131
};
const BetRadarSortingTotalsMarketsTypes = [
  BetRadarFactorTypes[
    "total"
    /* total */
  ],
  BetRadarFactorTypes[
    "handicap"
    /* handicap */
  ],
  BetRadarFactorTypes[
    "gameHandicap"
    /* gameHandicap */
  ],
  BetRadarFactorTypes[
    "totalGames"
    /* totalGames */
  ],
  BetRadarFactorTypes[
    "handicapInning"
    /* handicapInning */
  ],
  BetRadarFactorTypes[
    "totalInning"
    /* totalInning */
  ],
  BetRadarFactorTypes[
    "frameHandicap"
    /* frameHandicap */
  ],
  BetRadarFactorTypes[
    "frameTotal"
    /* frameTotal */
  ],
  BetRadarFactorTypes[
    "overtimeHandicap"
    /* overtimeHandicap */
  ],
  BetRadarFactorTypes[
    "overtimeTotal"
    /* overtimeTotal */
  ],
  BetRadarFactorTypes[
    "pointHandicap"
    /* pointHandicap */
  ],
  BetRadarFactorTypes[
    "setHandicap"
    /* setHandicap */
  ],
  BetRadarFactorTypes[
    "inningTotal"
    /* inningTotal */
  ],
  BetRadarFactorTypes[
    "totalMaps"
    /* totalMaps */
  ],
  BetRadarFactorTypes[
    "mapHandicap"
    /* mapHandicap */
  ],
  BetRadarFactorTypes[
    "totalSets"
    /* totalSets */
  ],
  BetRadarFactorTypes[
    "competitor1Total"
    /* competitor1Total */
  ],
  BetRadarFactorTypes[
    "competitor2Total"
    /* competitor2Total */
  ],
  BetRadarFactorTypes[
    "firstHalfTotal"
    /* firstHalfTotal */
  ],
  BetRadarFactorTypes[
    "firstHalfCompetitor1Total"
    /* firstHalfCompetitor1Total */
  ],
  BetRadarFactorTypes[
    "firstHalfCompetitor2Total"
    /* firstHalfCompetitor2Total */
  ],
  BetRadarFactorTypes[
    "secondHalfTotal"
    /* secondHalfTotal */
  ],
  BetRadarFactorTypes[
    "secondHalfCompetitor1Total"
    /* secondHalfCompetitor1Total */
  ],
  BetRadarFactorTypes[
    "secondHalfCompetitor2Total"
    /* secondHalfCompetitor2Total */
  ],
  BetRadarFactorTypes[
    "totalCorners"
    /* totalCorners */
  ],
  BetRadarFactorTypes[
    "firstHalfTotalCorners"
    /* firstHalfTotalCorners */
  ],
  BetRadarFactorTypes[
    "totalBookings"
    /* totalBookings */
  ],
  BetRadarFactorTypes[
    "firstHalfTotalBookings"
    /* firstHalfTotalBookings */
  ],
  BetRadarFactorTypes[
    "totalBookingsPoints"
    /* totalBookingsPoints */
  ],
  BetRadarFactorTypes[
    "firstHalfTotalBookingsPoints"
    /* firstHalfTotalBookingsPoints */
  ],
  BetRadarFactorTypes[
    "threeWayBetting"
    /* threeWayBetting */
  ],
  BetRadarFactorTypes[
    "totalAndBothTeamsToScore"
    /* totalAndBothTeamsToScore */
  ],
  BetRadarFactorTypes[
    "firstHalfThreeWayBetting"
    /* firstHalfThreeWayBetting */
  ],
  BetRadarFactorTypes[
    "secondHalfThreeWayBetting"
    /* secondHalfThreeWayBetting */
  ],
  BetRadarFactorTypes[
    "doubleChanceAndTotal"
    /* doubleChanceAndTotal */
  ],
  BetRadarFactorTypes[
    "halfTimeFullTimeTotal"
    /* halfTimeFullTimeTotal */
  ],
  BetRadarFactorTypes[
    "halfTimeFullTimeFirstHalfTotal"
    /* halfTimeFullTimeFirstHalfTotal */
  ],
  BetRadarFactorTypes[
    "handicapHcp"
    /* handicapHcp */
  ],
  BetRadarFactorTypes[
    "firstHalfHandicap"
    /* firstHalfHandicap */
  ],
  BetRadarFactorTypes[
    "firstHalfHandicapHcp"
    /* firstHalfHandicapHcp */
  ],
  BetRadarFactorTypes[
    "secondHalfHandicap"
    /* secondHalfHandicap */
  ],
  BetRadarFactorTypes[
    "secondHalfHandicapHcp"
    /* secondHalfHandicapHcp */
  ],
  BetRadarFactorTypes[
    "cornerHandicap"
    /* cornerHandicap */
  ],
  BetRadarFactorTypes[
    "firstHalfCornerHandicap"
    /* firstHalfCornerHandicap */
  ],
  BetRadarFactorTypes[
    "gameTotalPoints"
    /* gameTotalPoints */
  ],
  BetRadarFactorTypes[
    "gamePointHandicap"
    /* gamePointHandicap */
  ],
  BetRadarFactorTypes[
    "innings1To5Total"
    /* innings1To5Total */
  ],
  BetRadarFactorTypes[
    "competitor1TotalIncludeExtraInnings"
    /* competitor1TotalIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "competitor2TotalIncludeExtraInnings"
    /* competitor2TotalIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "totalOverExactUnderIncludeExtraInnings"
    /* totalOverExactUnderIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "innings1to5Competitor1Total"
    /* innings1to5Competitor1Total */
  ],
  BetRadarFactorTypes[
    "innings1to5Competitor2Total"
    /* innings1to5Competitor2Total */
  ],
  BetRadarFactorTypes[
    "inningTotal"
    /* inningnrTotal */
  ],
  BetRadarFactorTypes[
    "winnerAndTotalIncludeExtraInnings"
    /* winnerAndTotalIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "totalHitsIncludeExtraInnings"
    /* totalHitsIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "competitor1TotalHitsIncludeExtraInnings"
    /* competitor1TotalHitsIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "competitor2TotalHitsIncludeExtraInnings"
    /* competitor2TotalHitsIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "inningTotalHits"
    /* inningTotalHits */
  ],
  BetRadarFactorTypes[
    "inningCompetitor1TotalHits"
    /* inningCompetitor1TotalHits */
  ],
  BetRadarFactorTypes[
    "inningCompetitor2TotalHits"
    /* inningCompetitor2TotalHits */
  ],
  BetRadarFactorTypes[
    "innings1To5TotalHits"
    /* innings1To5TotalHits */
  ],
  BetRadarFactorTypes[
    "innings1To5Competitor1TotalHits"
    /* innings1To5Competitor1TotalHits */
  ],
  BetRadarFactorTypes[
    "innings1To5Competitor2TotalHits"
    /* innings1To5Competitor2TotalHits */
  ],
  BetRadarFactorTypes[
    "totalHomeRunsIncludeExtraInnings"
    /* totalHomeRunsIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "competitor1TotalHomeRunsIncludeExtraInnings"
    /* competitor1TotalHomeRunsIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "competitor2TotalHomeRunsIncludeExtraInnings"
    /* competitor2TotalHomeRunsIncludeExtraInnings */
  ],
  BetRadarFactorTypes[
    "innings1To5Handicap"
    /* innings1To5Handicap */
  ],
  BetRadarFactorTypes[
    "quarternrTotal"
    /* quarternrTotal */
  ],
  BetRadarFactorTypes[
    "quarternrCompetitor1Total"
    /* quarternrCompetitor1Total */
  ],
  BetRadarFactorTypes[
    "quarternrCompetitor2Total"
    /* quarternrCompetitor2Total */
  ],
  BetRadarFactorTypes[
    "competitor1TotalMaximumConsecutivePoints"
    /* competitor1TotalMaximumConsecutivePoints */
  ],
  BetRadarFactorTypes[
    "competitor2TotalMaximumConsecutivePoints"
    /* competitor2TotalMaximumConsecutivePoints */
  ],
  BetRadarFactorTypes[
    "anyTeamTotalMaximumConsecutivePoints"
    /* anyTeamTotalMaximumConsecutivePoints */
  ],
  BetRadarFactorTypes[
    "competitor1TotalIncludeOvertime"
    /* competitor1TotalIncludeOvertime */
  ],
  BetRadarFactorTypes[
    "competitor2TotalIncludeOvertime"
    /* competitor2TotalIncludeOvertime */
  ],
  BetRadarFactorTypes[
    "winnerAndTotalIncludeOvertime"
    /* winnerAndTotalIncludeOvertime */
  ],
  BetRadarFactorTypes[
    "totalOverExactUnder"
    /* totalOverExactUnder */
  ],
  BetRadarFactorTypes[
    "quarternrHandicap"
    /* quarternrHandicap */
  ],
  BetRadarFactorTypes[
    "setTotalPoints"
    /* setTotalPoints */
  ],
  BetRadarFactorTypes[
    "setPointHandicap"
    /* setPointHandicap */
  ],
  BetRadarFactorTypes[
    "inningsCompetitor1Total"
    /* inningsCompetitor1Total */
  ],
  BetRadarFactorTypes[
    "inningsCompetitor2Total"
    /* inningsCompetitor2Total */
  ],
  BetRadarFactorTypes[
    "inningsOversZeroToCompetitor1Total"
    /* inningsOversZeroToCompetitor1Total */
  ],
  BetRadarFactorTypes[
    "inningsOversZeroToCompetitor2Total"
    /* inningsOversZeroToCompetitor2Total */
  ],
  BetRadarFactorTypes[
    "firstOverTotal"
    /* firstOverTotal */
  ],
  BetRadarFactorTypes[
    "total180s"
    /* total180s */
  ],
  BetRadarFactorTypes[
    "setTotalLegs"
    /* setTotalLegs */
  ],
  BetRadarFactorTypes[
    "competitor1Total180s"
    /* competitor1Total180s */
  ],
  BetRadarFactorTypes[
    "competitor2Total180s"
    /* competitor2Total180s */
  ],
  BetRadarFactorTypes[
    "setLegHandicap"
    /* setLegHandicap */
  ],
  BetRadarFactorTypes[
    "handicap180s"
    /* handicap180s */
  ],
  BetRadarFactorTypes[
    "mapTotalRoundsIncludeOvertime"
    /* mapTotalRoundsIncludeOvertime */
  ],
  BetRadarFactorTypes[
    "mapRoundHandicapIncludeOvertime"
    /* mapRoundHandicapIncludeOvertime */
  ],
  BetRadarFactorTypes[
    "setTotalGames"
    /* setTotalGames */
  ],
  BetRadarFactorTypes[
    "competitor1TotalGames"
    /* competitor1TotalGames */
  ],
  BetRadarFactorTypes[
    "competitor2TotalGames"
    /* competitor2TotalGames */
  ],
  BetRadarFactorTypes[
    "winnerAndTotal"
    /* winnerAndTotal */
  ],
  BetRadarFactorTypes[
    "setGameHandicap"
    /* setGameHandicap */
  ],
  BetRadarFactorTypes[
    "asianTotal"
    /* asianTotal */
  ],
  BetRadarFactorTypes[
    "asianHandicap"
    /* asianHandicap */
  ]
];
const BetRadarHandicapMarketTypes = [
  BetRadarFactorTypes[
    "handicap"
    /* handicap */
  ],
  BetRadarFactorTypes[
    "gameHandicap"
    /* gameHandicap */
  ],
  BetRadarFactorTypes[
    "handicapInning"
    /* handicapInning */
  ],
  BetRadarFactorTypes[
    "setHandicap"
    /* setHandicap */
  ],
  BetRadarFactorTypes[
    "mapHandicap"
    /* mapHandicap */
  ],
  BetRadarFactorTypes[
    "asianHandicap"
    /* asianHandicap */
  ]
];
const BetRadarTotalMarketTypes = [
  BetRadarFactorTypes[
    "total"
    /* total */
  ],
  BetRadarFactorTypes[
    "totalGames"
    /* totalGames */
  ],
  BetRadarFactorTypes[
    "totalInning"
    /* totalInning */
  ],
  BetRadarFactorTypes[
    "frameTotal"
    /* frameTotal */
  ],
  BetRadarFactorTypes[
    "overtimeTotal"
    /* overtimeTotal */
  ],
  BetRadarFactorTypes[
    "setHandicap"
    /* setHandicap */
  ],
  BetRadarFactorTypes[
    "inningTotal"
    /* inningTotal */
  ],
  BetRadarFactorTypes[
    "totalSets"
    /* totalSets */
  ],
  BetRadarFactorTypes[
    "totalMaps"
    /* totalMaps */
  ],
  BetRadarFactorTypes[
    "asianTotal"
    /* asianTotal */
  ]
];
const outrightTypes = [BetRadarEventType.TOURNAMENT, BetRadarEventType.SEASON, BetRadarEventType.STAGE];
const convertBetSlipEntityToMarketTitleData = (bet, translations, players, variants, event, competitors) => ({
  players,
  variants,
  competitors,
  event: { ...event, eventType: bet.eventType },
  marketTranslations: translations,
  odd: { id: `${bet.marketId}`, specifiers: bet.specifiers }
});
const selectOddsTranslateByMarket = createSelector(
  (translations) => translations,
  (translations, bet) => bet,
  (translations, bet, event) => event,
  (translations, bet, event, players) => players,
  (translations, bet, event, players, variants) => variants,
  (translations, bet, event, players, variants, competitors) => competitors || {},
  (translations, bet, event, players, variants, competitors) => {
    const name = generateMarketTitle(
      bet.marketType || OutcomeTypes.normal,
      convertBetSlipEntityToMarketTitleData(
        bet,
        translations,
        players,
        variants,
        event,
        competitors
      )
    );
    if (name && event) {
      return __(replaceTeams(name, event));
    }
    return __(name);
  }
);
const selectOddsTranslateByOutcome = createSelector(
  (translations) => translations || getOutcomesTranslations(),
  (translations, bet) => bet,
  (translations, bet, event) => event,
  (translations, bet, event, players) => players || [],
  (translations, bet, event, players, variants) => variants || {},
  (translations, bet, event, players, variants, competitors) => competitors || {},
  (translations, bet, event, players, variants, competitors) => {
    try {
      const outcomeName = generateOutcomeByType(bet == null ? void 0 : bet.outcomeType, {
        event,
        players,
        variants,
        competitors,
        outcome: {
          id: `${bet.outcomeId}`,
          type: bet == null ? void 0 : bet.outcomeType
        },
        outcomeTranslations: translations,
        specifier: bet == null ? void 0 : bet.specifiers
      });
      if (!!outcomeName && !!event) {
        let withTeams = replaceTeams(outcomeName, event);
        const specifiers = bet.specifiers.split("|");
        specifiers.forEach((partSpecifier) => {
          if (partSpecifier.includes("score=")) {
            const specifier = partSpecifier.replace("score=", "");
            withTeams = `${withTeams} (${specifier})`;
          }
        });
        return withTeams;
      }
    } catch (e) {
      console.log("player cannot be parsed", e);
    }
    return bet == null ? void 0 : bet.outcomeId;
  }
);
const selectOddsByOutcomeAndMarket = createSelector(
  (odds) => odds || [],
  (odds, marketId) => Number(marketId),
  (odds, marketId, outcomeId) => Number(outcomeId),
  (odds, marketId, outcomeId, specifier) => specifier || null,
  (odds, marketId, outcomeId, specifier) => {
    var _a;
    const market = (odds.filter((odd) => odd.status === BetRadarEntityStatus.active) || []).find(
      (odd) => Number(odd.id) === marketId && (specifier ? odd.specifiers === specifier : true)
    );
    if (!!market && !!market.outcomes && !!market.outcomes.length) {
      return ((_a = market.outcomes.find((outcome) => Number(outcome.id) === outcomeId)) == null ? void 0 : _a.odds) || null;
    }
    return null;
  }
);
const selectCompetitorNameById = createSelector(
  (competitors) => competitors || [],
  (competitors, id) => id,
  (competitors, id) => {
    const competitor = competitors.find(
      (competitor2) => Number(competitor2.id) === Number(id)
    );
    if (competitor == null ? void 0 : competitor.name) {
      return competitor;
    }
    return { name: __("Default_._Text_._Unknown") };
  }
);
const selectCompetitorAgeGroupById = createSelector(
  (competitors) => competitors || [],
  (competitors, id) => id,
  (competitors, id) => {
    const competitor = competitors.find(
      (competitor2) => Number(competitor2.id) === Number(id)
    );
    if (competitor == null ? void 0 : competitor.ageGroup) {
      return competitor;
    }
    return { ageGroup: "" };
  }
);
const isSortingTotalMarket = (marketId, specifier) => BetRadarSortingTotalsMarketsTypes.includes(Number(marketId)) || specifier && specifier.indexOf("total") !== -1;
const isHandicapMarket = (specifier) => specifier == null ? void 0 : specifier.includes("hcp");
const isOnlyHandicapMarket = (marketId, specifier) => BetRadarHandicapMarketTypes.includes(Number(marketId)) || specifier && specifier.indexOf("hcp") !== -1;
const isOnlyTotalMarket = (marketId, specifier) => BetRadarTotalMarketTypes.includes(Number(marketId)) || specifier && specifier.indexOf("total") !== -1;
var OddsCategory = /* @__PURE__ */ ((OddsCategory2) => {
  OddsCategory2["main"] = "db column_._backoffice_._main";
  OddsCategory2["other"] = "db column_._backoffice_._others";
  return OddsCategory2;
})(OddsCategory || {});
const findCategoryByOddId = createSelector(
  (oddId) => Number(oddId),
  (oddId, marketTranslations) => marketTranslations,
  (oddId, marketTranslations) => (marketTranslations || []).find((market) => market.id === oddId) || null
);
const filterOddsByCategorySpecifiers = (group, specifiers) => {
  if (group.specifier && typeof specifiers === "string") {
    const specifiersArray = specifiers.split("|");
    const groupSpecifier = `${group.specifier}=${group.specifierValue}`;
    return specifiersArray.includes(groupSpecifier);
  }
  return true;
};
const selectOddCategoryName = createSelector(
  (marketGroup) => marketGroup,
  (marketGroup, sort) => sort,
  (marketGroup, sort, sportId) => sportId,
  (marketGroup, sort, sportId, specifiers) => specifiers,
  (marketGroup, sort, sportId, specifiers, isLive) => isLive,
  (marketGroup, sort, sportId, specifiers, isLive) => {
    performance.now();
    const sortedNames = makeMarketSortedNames(sort);
    if (marketGroup == null ? void 0 : marketGroup.marketGroups) {
      const groupList = [
        ...new Set(
          (marketGroup.marketGroups || []).filter((group) => group.isLive === void 0 || !!group.isLive === isLive).filter((group) => Number(group.sportId) === Number(sportId)).filter((group) => filterOddsByCategorySpecifiers(group, specifiers)).map((groupName) => groupName.name).filter((groupName) => Array.isArray(sortedNames) ? sortedNames.includes(groupName) : true).filter((groupName) => !!groupName)
        )
      ];
      return groupList.length ? groupList : [
        "db column_._backoffice_._others"
        /* other */
      ];
    }
    return [
      "db column_._backoffice_._others"
      /* other */
    ];
  }
);
const selectGroupIndex = createSelector(
  (marketGroup) => marketGroup || [],
  (marketGroup, marketName) => marketName,
  (marketGroup, marketName) => {
    const index = marketGroup.findIndex((group) => group === marketName);
    return index < 0 ? 99999 : index;
  }
);
const selectMarketIndex = createSelector(
  (id) => Number(id),
  (id, marketSort) => marketSort || [],
  (id, marketSort) => {
    const index = marketSort.findIndex((market) => Number(market) === id);
    return index < 0 ? 99999 : index;
  }
);
const getOutcomePlayer = createSelector(
  (outcome) => outcome,
  (outcome, specifier) => specifier || "",
  (outcome, specifier) => {
    if (outcome.type === OutcomeTypes.player) {
      return outcome.id;
    }
    if (specifier.includes("player=sr:player:")) {
      const specifierParts = specifier.split("|");
      const playerPart = (specifierParts || []).find((part) => part.includes("player=sr:player:"));
      if (playerPart) {
        return playerPart.split("player=sr:player:")[1];
      }
    }
    return null;
  }
);
const replaceVariantValue = createSelector(
  (outcomeId) => Number(outcomeId),
  (outcomeId, variants) => variants || {},
  (outcomeId, variants) => {
    var _a;
    return ((_a = variants[outcomeId]) == null ? void 0 : _a.name) || "";
  }
);
const outcomeDefaultName = ({
  specifier,
  outcome,
  outcomeTranslations,
  event,
  players,
  competitors
}) => generateOutcomeNameBySpecifier(
  selectOutcomeName(outcome, outcomeTranslations),
  specifier,
  event,
  players,
  competitors
);
const outcomePlayerName = ({
  outcome,
  specifier,
  players
}) => {
  const player = getOutcomePlayer(outcome, specifier);
  if (player) {
    return replacePlayerName("", players || [], player);
  }
  return null;
};
const outcomeVariantName = ({
  outcome,
  variants,
  event
}) => {
  const variantValue = replaceVariantValue(outcome.id, variants);
  return replaceTeams(variantValue, event);
};
const outcomeCompetitorType = ({
  outcome,
  competitors
}) => {
  var _a;
  return ((_a = (competitors || {})[outcome.id]) == null ? void 0 : _a.name) || "";
};
const generateOutcomeByType = (type, data) => {
  const outcomeType = type || OutcomeTypes.normal;
  const { specifier, outcome } = data;
  const mappedTypes = {
    [OutcomeTypes.player]: outcomePlayerName,
    [OutcomeTypes.normal]: outcomeDefaultName,
    [OutcomeTypes.variant]: outcomeVariantName,
    [OutcomeTypes.competitors]: outcomeCompetitorType
  };
  const outcomeName = mappedTypes[outcomeType](data);
  if (specifier && specifier.includes("player=sr:player:") && outcome.type === OutcomeTypes.normal) {
    return `${outcomePlayerName(data)}: ${outcomeName}`;
  }
  return outcomeName;
};
const titleByPlayer = ({ odd, players }) => {
  var _a;
  return (_a = findPlayerById(odd.id, players)) == null ? void 0 : _a.name;
};
const titleByDefault = ({
  odd,
  marketTranslations,
  players,
  event,
  competitors
}) => selectMarketName(odd, marketTranslations, players, event, competitors);
const titleByVariant = ({ odd, variants }) => {
  var _a;
  const name = (_a = findVariantById(odd.id, variants)) == null ? void 0 : _a.name;
  return name;
};
const getMarketType = (eventType, marketType) => {
  if (eventType === BetRadarEventType.MATCH) {
    return OutcomeTypes.normal;
  }
  return marketType;
};
const generateMarketTitle = (type, data) => {
  const { event, odd } = data;
  const { eventType } = event;
  const marketType = getMarketType(
    eventType || BetRadarEventType.MATCH,
    type || OutcomeTypes.normal
  );
  const mappedTypes = {
    [OutcomeTypes.player]: titleByPlayer,
    [OutcomeTypes.normal]: titleByDefault,
    [OutcomeTypes.variant]: titleByVariant
  };
  try {
    const name = mappedTypes[marketType](data);
    if (!name) {
      return titleByDefault(data);
    }
    return name;
  } catch (e) {
    return `${(odd == null ? void 0 : odd.id) ?? ""}`;
  }
};
const filterOddsData = (odds, event) => odds.filter((odd) => !!odd.outcomes && !!odd.outcomes.length).filter((odd) => {
  if ("status" in event) {
    return event.status === EventStatus.line ? [BetRadarEntityStatus.active, BetRadarEntityStatus.suspended].includes(odd.status) : [
      BetRadarEntityStatus.active,
      BetRadarEntityStatus.suspended
    ].includes(odd.status);
  }
  return [BetRadarEntityStatus.active].includes(odd.status);
});
const sortOddsData = (odds, sort) => odds.sort((oddA, oddB) => {
  if (sort) {
    const aIndex = selectMarketIndex(oddA.id, sort.markets);
    const bIndex = selectMarketIndex(oddB.id, sort.markets);
    return aIndex - bIndex;
  }
  return null;
}).sort((oddA, oddB) => {
  if (oddA.id === oddB.id && !!oddA.specifiers && !!oddB.specifiers) {
    const [, aIndex] = oddA.specifiers.split("=");
    const [, bIndex] = oddB.specifiers.split("=");
    if (!isNaN(aIndex) && !isNaN(bIndex)) {
      return aIndex - bIndex;
    }
  }
  return null;
});
const sortedOutright = (outcomes) => {
  const isEventOutright = outcomes.every((item) => item.eventType && outrightTypes.includes(item.eventType));
  return isEventOutright ? outcomes.sort((a, b) => a.v - b.v) : outcomes;
};
const betRadarMarketsGeneration = (odds, event, marketTranslations, outcomeTranslations, dynamicData, sort, tips, oddsBoosted, favoriteMarketIds) => {
  const { players, variants, competitors } = dynamicData || {};
  const marketsData = /* @__PURE__ */ new Map();
  const isLiveEvent = event.status !== EventStatus.line;
  sortOddsData(
    filterOddsData(odds, event),
    event.eventType !== BetRadarEventType.MATCH ? sort : null
  ).forEach((odd) => {
    try {
      const { eventType } = event;
      const boostedOutcomes = [];
      let name = generateMarketTitle(odd.type, {
        players,
        event,
        variants,
        marketTranslations,
        odd,
        competitors
      });
      name = `${replaceTeams(name, event)}`;
      const key = generateOutcomeKey(odd.id, odd.specifiers);
      const tip = tips == null ? void 0 : tips.find((tip2) => tip2.marketId === Number(odd.id) && tip2.specifier === odd.specifiers);
      let outcomeData = odd.outcomes.map((outcome) => {
        const outcomeName = generateOutcomeByType(outcome.type, {
          competitors,
          outcome,
          players,
          variants,
          outcomeTranslations,
          event,
          specifier: odd.specifiers
        });
        const preparedOutcome = {
          name: outcomeName,
          v: outcome.odds,
          id: outcome.id,
          marketId: odd.id,
          marketType: odd.type,
          team: outcome.team,
          specifiers: odd.specifiers,
          status: odd.status,
          eventType: eventType ?? BetRadarEventType.MATCH,
          type: outcome.type,
          active: outcome.active
        };
        if (tip && Number(outcome.id) === tip.outcomeId) {
          marketsData.set(`${analytics}--${key}`, {
            title: tip.text,
            category: analytics,
            key,
            outcomes: [preparedOutcome],
            status: odd.status,
            betName: name,
            marketMetadata: odd.marketMetadata
          });
        }
        return preparedOutcome;
      });
      if (isOnlyTotalMarket(odd.id, odd.specifiers)) {
        outcomeData = outcomeData.sort((a, b) => Number(a.id) - Number(b.id));
      }
      sortedOutright(outcomeData);
      const hasBoosted = hasBoostedOdds(oddsBoosted, odd, event.id);
      if (hasBoosted) {
        boostedOutcomes.push(...outcomeData);
      }
      marketsData.set(key, {
        title: name,
        category: selectOddCategoryName(
          findCategoryByOddId(odd.id, marketTranslations),
          sort,
          event.sportId,
          odd.specifiers,
          isLiveEvent
        ).join("|"),
        key,
        outcomes: outcomeData,
        status: odd.status,
        marketMetadata: odd.marketMetadata,
        sortId: odd.id
      });
      if (!!favoriteMarketIds && favoriteMarketIds.includes(Number(odd.id))) {
        marketsData.set(`${favorites}--${key}`, {
          title: name,
          category: favorites,
          key,
          outcomes: outcomeData,
          status: odd.status,
          marketMetadata: odd.marketMetadata,
          sortId: odd.id
        });
      }
      if (boostedOutcomes.length) {
        marketsData.set(`${key}--${boostedOdds}`, {
          title: name,
          category: boostedOdds,
          key,
          outcomes: boostedOutcomes,
          status: odd.status,
          marketMetadata: odd.marketMetadata,
          sortId: odd.id
        });
      }
    } catch (e) {
      console.error("market parse failed", e);
    }
  });
  return marketsData;
};
const generateOutcomeKey = (id, specifiers) => specifiers ? `${id}_${specifiers}` : `${id}`;
const generateMarketIdFromKey = (marketKey) => {
  const marketSplit = marketKey.split("_");
  return marketSplit.length > 1 ? marketSplit[0] : marketKey;
};
const selectMarketName = createSelector(
  (market) => market,
  (market, marketTranslations) => marketTranslations,
  (market, marketTranslations, players) => players,
  (market, marketTranslations, players, event) => event,
  (market, marketTranslations, players, event, competitors) => competitors,
  (market, marketTranslations, players, event, competitors) => {
    var _a;
    let name = (_a = (marketTranslations || []).find(
      (translation) => Number(translation.id) === Number(market.id)
    )) == null ? void 0 : _a.name;
    if (market.specifiers) {
      name = replaceSpecifierToValues(name, market.specifiers, players || [], false, event, competitors);
    }
    return name;
  }
);
const selectOutcomeName = createSelector(
  (outcome) => outcome,
  (outcome, outcomeTranslation) => outcomeTranslation || [],
  (outcome, outcomeTranslation) => {
    var _a;
    return (_a = outcomeTranslation.find(
      (translation) => Number(translation.id) === Number(outcome.id)
    )) == null ? void 0 : _a.name;
  }
);
const replaceSpecifierToValues = (name, specifiers, players, isOutcome, event, competitors) => replaceSpecifierToValuesSelector(name, specifiers, players, isOutcome, event, competitors || {});
const mappedTranslatedNr = {
  1: __("Translated Nr_._Option_._st"),
  2: __("Translated Nr_._Option_._nd"),
  3: __("Translated Nr_._Option_._rd"),
  4: __("Translated Nr_._Option_._th"),
  5: __("Translated Nr_._Option_._th"),
  6: __("Translated Nr_._Option_._th"),
  7: __("Translated Nr_._Option_._th"),
  8: __("Translated Nr_._Option_._th"),
  9: __("Translated Nr_._Option_._th"),
  0: __("Translated Nr_._Option_._th")
};
const replaceNumberToString = createSelector(
  (number) => `${number}`,
  (number) => {
    const valueArray = `${number}`.split("");
    const translatableGoal = mappedTranslatedNr[valueArray[valueArray.length - 1]];
    return `${number}${translatableGoal}`;
  }
);
const numberMarkets = [
  "cornernr",
  "goalnr",
  "bookingnr",
  "setnr",
  "gamenr",
  "pointnr",
  "inningnr",
  "quarternr",
  "fieldgoalnr"
];
const playersOutcomes = ["player1", "player2", "player"];
const CoddsMarketSpecifierNames = {
  team: "team",
  competitor: "competitor"
};
const replaceSpecifierToValuesSelector = createSelector(
  (name) => name || "",
  (name, specifiers) => specifiers || "",
  (name, specifiers, players) => players || [],
  (name, specifiers, players, isOutcome) => isOutcome,
  (name, specifiers, players, isOutcome, event) => event,
  (name, specifiers, players, isOutcome, event, competitors) => competitors,
  (name, specifiers, players, isOutcome, event, competitors) => {
    let parsedName = name;
    const splittedSpecifier = specifiers.split("|");
    splittedSpecifier.forEach((specifier) => {
      var _a, _b, _c;
      const specifierPartial = specifier.split("=");
      const [specifierName] = specifierPartial;
      const [, specifierValue] = specifierPartial;
      const getHandicapPositiveValue = () => getHandicapPositiveValueSelector(specifierValue);
      const getHandicapNegativeValue = () => getHandicapNegValueSelector(specifierValue);
      const replaceData = () => {
        return specifierValue;
      };
      const replaceOrdinalNumber = () => {
        if (numberMarkets.includes(specifierName)) {
          if (!(specifiers.split("|").length > 2 && specifierName === "pointnr")) {
            return replaceNumberToString(specifierValue);
          }
        }
        return specifierValue;
      };
      const replacePlayers = () => {
        const player = specifierValue.split("sr:player:");
        return replacePlayerName("", players, player[1]);
      };
      const replaceCompetitors = () => {
        var _a2;
        try {
          return ((_a2 = competitors[specifierValue]) == null ? void 0 : _a2.name) || "";
        } catch (e) {
          return null;
        }
      };
      parsedName = parsedName.replace(`{${specifierName}}`, replaceData).replace(`{+${specifierName}}`, `${getHandicapPositiveValue()}`).replace(`{-${specifierName}}`, `${getHandicapNegativeValue()}`).replace(`{!${specifierName}}`, replaceOrdinalNumber);
      if (playersOutcomes.includes(specifierName) && isOutcome) {
        parsedName = parsedName.replace(`{%${specifierName}}`, replacePlayers);
      }
      if (specifierName === CoddsMarketSpecifierNames.team && !!Object.keys(competitors).length) {
        parsedName = (_a = parsedName.replace(`{%${specifierName}}`, replaceCompetitors)) == null ? void 0 : _a.trim();
      }
      if (isOutcome) {
        if (!!Object.keys(competitors).length) {
          if (!specifierValue.includes("sr:competitor")) {
            parsedName = (_b = parsedName.replace(`{%${specifierName}}`, replaceCompetitors)) == null ? void 0 : _b.trim();
          }
        }
      }
      if (specifierName === CoddsMarketSpecifierNames.competitor && !!Object.keys(competitors).length) {
        parsedName = (_c = parsedName.replace(`{%${specifierName}}`, replaceCompetitors)) == null ? void 0 : _c.trim();
      }
    });
    if (!isOutcome && specifiers.includes("server=")) {
      const [, competitorId] = specifiers.match(/server=(\d+)/);
      let competitorName;
      if (Number(event.competitor1Id) === Number(competitorId)) {
        competitorName = event.team1;
      }
      if (Number(event.competitor2Id) === Number(competitorId)) {
        competitorName = event.team2;
      }
      if (competitorName) {
        parsedName = `${competitorName} ${parsedName}`;
      }
    }
    return parsedName;
  }
);
const replacePlayerName = createSelector(
  (name) => name || "",
  (name, players) => players || [],
  (name, players, specifier) => Number(specifier),
  (name, players, specifier) => {
    var _a;
    const player = (_a = (Object.values(players) || []).find(
      (currentPlayer) => Number(currentPlayer.id) === specifier
    )) == null ? void 0 : _a.name;
    return player ? `${player}` : name;
  }
);
const findPlayerById = createSelector(
  (id) => Number(id),
  (id, players) => players || [],
  (id, players) => players.find((player) => Number(player.id) === id)
);
const findVariantById = createSelector(
  (id) => Number(id),
  (id, variants) => variants || {},
  (id, variants) => variants[id]
);
const getHandicapPositiveValueSelector = createSelector(
  (value) => Number(value),
  (value) => {
    if (value > 0) {
      return `+${Math.abs(value)}`;
    } else if (value < 0) {
      return `-${Math.abs(value)}`;
    } else {
      return `${value}`;
    }
  }
);
const getHandicapNegValueSelector = createSelector(
  (value) => Number(value),
  (value) => {
    if (value < 0) {
      return `+${Math.abs(value)}`;
    } else if (value > 0) {
      return `-${Math.abs(value)}`;
    } else {
      return `${value}`;
    }
  }
);
const replaceTeamSelector = createSelector(
  (name) => name || "",
  (name, team1) => team1 || __("Default_._Text_._Unknown"),
  (name, team1, team2) => team2 || __("Default_._Text_._Unknown"),
  (name, team1, team2) => (name || "").replace(/\{\$competitor1\}/g, team1).replace(/\{\$competitor2\}/g, team2).replace(/\{%competitor\}\s?/g, "").replace(/\{%server\}/g, "").replace(/\{%player\}\s?/g, "").replace(/\{\$?home\}/g, team1).replace(/\{\$?away\}/g, team2)
);
const replaceTeams = (name, event) => {
  if (event) {
    const { team1, team2 } = event;
    if (team1 || team2) {
      return replaceTeamSelector(name, team1, team2);
    }
  }
  return name;
};
const replaceInningByNumber = createSelector(
  (parsedName) => parsedName,
  (parsedName, specifiers) => specifiers,
  (parsedName, specifiers) => {
    try {
      const [, specifierNumber] = (specifiers.split("|") || []).find((specifier) => specifier.includes("inningnr")).split("=");
      const replaceData = (subStr, ...args) => `${Number(specifierNumber) + Number(args[0])}`;
      return parsedName.replace(/\{\!\(inningnr\+([0-9]+)\)\}/, replaceData);
    } catch (e) {
      return null;
    }
  }
);
const generateOutcomeNameBySpecifier = createSelector(
  (name) => name || "",
  (name, specifier) => specifier || null,
  (name, specifier, event) => event,
  (name, specifier, event, players) => players || [],
  (name, specifier, event, players, competitors) => competitors || {},
  (name, specifier, event, players, competitors) => {
    let parsedName = name;
    if (specifier) {
      parsedName = replaceSpecifierToValues(
        parsedName,
        specifier,
        players,
        true,
        event,
        competitors
      );
    }
    if (parsedName.includes("inningnr")) {
      parsedName = replaceInningByNumber(parsedName, specifier);
    }
    return replaceTeams(parsedName, event);
  }
);
export {
  BetRadarFactorTypes,
  BetRadarSortingTotalsMarketsTypes,
  OddsCategory,
  betRadarMarketsGeneration,
  betRadarSetupMarkets,
  betRadarSetupOutcomes,
  betRadarSetupStatus,
  betRadarSetupVariants,
  generateMarketIdFromKey,
  generateMarketTitle,
  generateOutcomeByType,
  getMarketTranslations,
  getOutcomePlayer,
  getOutcomesTranslations,
  getVariantTranslations,
  isHandicapMarket,
  isOnlyHandicapMarket,
  isOnlyTotalMarket,
  isSortingTotalMarket,
  replaceSpecifierToValues,
  replaceTeamSelector,
  replaceTeams,
  selectCompetitorAgeGroupById,
  selectCompetitorNameById,
  selectGroupIndex,
  selectOddsByOutcomeAndMarket,
  selectOddsTranslateByMarket,
  selectOddsTranslateByOutcome,
  selectOutcomeName,
  sortedOutright
};
